export default "__VITE_ASSET__DDcccCrp__"